export default "__VITE_ASSET__49q1R4ZT__"